import Vue from "vue";
import "vant/lib/index.css";
import {
  Overlay,
  PasswordInput,
  NumberKeyboard,
  Search,
  Tab,
  Tabs,
  NavBar,
  Tabbar,
  TabbarItem,
  Icon,
  Field,
  Cell,
  CellGroup,
  Button,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  DatetimePicker,
  Popup,
  Toast,
  Picker,
  Dialog,
  Row,
  Col,
  ActionSheet,
  Uploader,
  Switch,
  Collapse,
  CollapseItem,
  Swipe,
  SwipeItem,
  Image,
  Lazyload,
  Grid,
  GridItem,
  CountDown,
  SwipeCell,
  TreeSelect,
  Stepper,
  ImagePreview,
  Sidebar,
  SidebarItem,
  Empty,
  NoticeBar,
  Sticky,
  Form
} from "vant";

Vue.use(Tabbar).use(TabbarItem);
Vue.use(Cell).use(CellGroup);
Vue.use(Checkbox).use(CheckboxGroup);
Vue.use(Row).use(Col);
Vue.use(NavBar);
Vue.use(Icon);
Vue.use(Field);
Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(Dialog);
Vue.use(ActionSheet);
Vue.use(Tab).use(Tabs);
Vue.use(Search);
Vue.use(Uploader);
// Vue.use(Badge)
Vue.use(Switch);

Vue.use(Overlay);
Vue.use(PasswordInput).use(NumberKeyboard);
Vue.use(Collapse).use(CollapseItem);
Vue.use(Swipe).use(SwipeItem);
Vue.use(Image);
Vue.use(Lazyload);
Vue.use(Grid).use(GridItem);
Vue.use(CountDown);
Vue.use(SwipeCell);
Vue.use(TreeSelect);
Vue.use(Stepper);
Vue.use(ImagePreview);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Empty);
Vue.use(NoticeBar);
Vue.use(Sticky);
Vue.use(Form);
